import { PayoutRuleType } from '@common-fe/common-fe';

import { ProcessingRuleTierUpdate } from '../../stores/useProcessingRuleTiersStore';

export const CARD_PURSE_LOCK = 'LOCK';
export const CARD_PURSE_UNLOCK = 'UNLOCK';

export interface TierUpdateComputation {
  tierUpdate?: ProcessingRuleTierUpdate;
  linkedPlanIds: string[];
}

export enum TierFormField {
  name = 'name',
  payoutDefinition = 'payoutDefinition',
  payoutRuleType = 'payoutRuleType',
  triggers = 'triggers',
  aggregateTriggerName = 'aggregateTriggerName',
  embeddedTriggerName = 'embeddedTriggerName',
  isSendTriggerNotification = 'isSendTriggerNotification',
  displayName = 'displayName',
  planName = 'planName',
  lockCardPurse = 'lockCardPurse',
  planIdsForCardPurseLock = 'planIdsForCardPurseLock',
  planNamesForCardPurseLock = 'planNamesForCardPurseLock',
}

export const LOCK_CARD_PURSE_OPTIONS = [
  { label: 'Lock', value: CARD_PURSE_LOCK },
  { label: 'Unlock', value: CARD_PURSE_UNLOCK },
];

export const PAYOUT_RULE_OPTIONS = [
  {
    key: PayoutRuleType.NO_EXCEPTIONS,
    value: 'No exceptions',
    hintIconText:
      'Account payment order will be used to process claims based on each tiers configured payout definition.',
  },
  {
    key: PayoutRuleType.WITH_EXCEPTIONS,
    value: 'With exceptions',
    hintIconText: 'Account payment order will be used but exceptions can be configured within each tier.',
  },
  {
    key: PayoutRuleType.EXCEPTIONS_ONLY,
    value: 'Exceptions only',
    hintIconText:
      'Account payment order will not be used. Claims will only pay according to each tiers specific rules.',
  },
];

export interface TierFormValues {
  [TierFormField.name]: string;
  [TierFormField.payoutDefinition]: string;
  [TierFormField.payoutRuleType]?: PayoutRuleType;
  [TierFormField.triggers]: string[];
  [TierFormField.aggregateTriggerName]?: string;
  [TierFormField.embeddedTriggerName]?: string;
  [TierFormField.isSendTriggerNotification]?: string;
  [TierFormField.displayName]?: string;
  [TierFormField.planName]?: string;
  [TierFormField.lockCardPurse]?: string;
  [TierFormField.planIdsForCardPurseLock]?: string[];
  [TierFormField.planNamesForCardPurseLock]?: string[];
}
